/* eslint no-console: 0 */
import { RemoteProduct } from '../../../data/usecases/products/remote-product'
import { extractHourToMinutes } from '../../../presentation/helpers/helper-date'
import { formatCurrency } from '../../../presentation/helpers/helper-price'
import { currencyFormatWithDisplay } from '../../configs/currency'
import { makeAxiosHttpClient } from '../../factories/http/axios-http-client-factory'

export const apiToFormik = async (response: any) => {
  if (!response) return { initialData: null, initialOrganizationData: null }
  const {
    file,
    goToKitchen,
    name,
    price,
    description,
    hasPreparationTime,
    preparationTime,
    hasStock,
    stock,
    categoryId,
    optionModel,
    preferenceItems,
  } = response

  const button = ''

  // preparationTime
  const time = extractHourToMinutes(preparationTime)
  const hour = hasPreparationTime ? String(time.hour) : ''
  const minute = hasPreparationTime ? String(time.minute) : ''

  // preference items
  const preferenceItemsParsed = JSON.parse(preferenceItems) || []

  const initialData = {
    goToKitchen: String(goToKitchen),
    name,
    price: formatCurrency(price, currencyFormatWithDisplay, 'pt-BR'),
    description,
    hasPreparationTime: String(hasPreparationTime),
    hasStock: String(hasStock),
    hour,
    minute,
    stock,
    button,
    file,
  }

  const initialOrganizationData = {
    categoryId: categoryId || '',
    optionModelId: optionModel?.id,
    preferenceItems: preferenceItemsParsed,
    button,
  }

  return { initialData, initialOrganizationData }
}

export const makeProduct = (stablismentId: number) => (
  new RemoteProduct(`/stablishments/${stablismentId}/products`, makeAxiosHttpClient())
)
